import { useMutation, useQueryClient } from "@tanstack/react-query";
import { editMember } from "src/redux/api/_customer.api";
import { memberKeys } from "./useFetchMembers";
import { toast } from "react-toastify";
import { EditMemberFormValues } from "../schema/edit-member.schema";

export const useEditMember = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      values,
      memberId,
      subscriptionId
    }: {
      values: Partial<EditMemberFormValues>;
      memberId: number;
      subscriptionId: number
    }) => editMember(values, memberId),

    onSuccess: (id: number ,{subscriptionId}) => {
      queryClient.invalidateQueries({
        queryKey: memberKeys.list(subscriptionId),
      });
      toast.success("Member updated successfully");
    },

    onError: (error) => {
      toast.error("Failed to update member");
      console.error(error);
    },
  });
};
